var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9369 20.4905L15.1198 13.6734C16.1777 12.3058 16.7499 10.6337 16.7499 8.87497C16.7499 6.76972 15.9283 4.79573 14.4426 3.30736C12.9568 1.819 10.9776 1 8.87497 1C6.77235 1 4.79311 1.82162 3.30736 3.30736C1.819 4.79311 1 6.76972 1 8.87497C1 10.9776 1.82162 12.9568 3.30736 14.4426C4.79311 15.9309 6.76972 16.7499 8.87497 16.7499C10.6337 16.7499 12.3032 16.1777 13.6708 15.1224L20.4879 21.9369C20.5079 21.9569 20.5316 21.9728 20.5578 21.9836C20.5839 21.9944 20.6119 22 20.6402 22C20.6684 22 20.6964 21.9944 20.7226 21.9836C20.7487 21.9728 20.7724 21.9569 20.7924 21.9369L21.9369 20.795C21.9569 20.775 21.9728 20.7513 21.9836 20.7252C21.9944 20.6991 22 20.6711 22 20.6428C22 20.6145 21.9944 20.5865 21.9836 20.5604C21.9728 20.5343 21.9569 20.5105 21.9369 20.4905ZM13.0329 13.0329C11.92 14.1433 10.4447 14.7549 8.87497 14.7549C7.30522 14.7549 5.82998 14.1433 4.71698 13.0329C3.60661 11.92 2.99499 10.4447 2.99499 8.87497C2.99499 7.30522 3.60661 5.82735 4.71698 4.71698C5.82998 3.60661 7.30522 2.99499 8.87497 2.99499C10.4447 2.99499 11.9226 3.60399 13.0329 4.71698C14.1433 5.82998 14.7549 7.30522 14.7549 8.87497C14.7549 10.4447 14.1433 11.9226 13.0329 13.0329Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f69d7b79fa007db715136cabea4f054b.svg";
export { ForwardRef as ReactComponent };